import { useRoutes } from 'react-router-dom';
import { getAdminRoutes } from 'src/routes/sections/admin';

export default function AdminRoutesLazy() {
  return useRoutes(getAdminRoutes());
}
